import SectionGaiaOracle from './SectionGaiaOracle'

export default SectionGaiaOracle
// eslint-disable-next-line import/export
export * from './SectionGaiaOracle'
